import(/* webpackMode: "eager" */ "/vercel/path0/components/Footer/Footer.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/about/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Reveal/Reveal.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/FinalCTA/FinalCTA.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
